/* Arctic Mullet theme — framework-free front-end */
(function () {
  function init() {
    var hdr = document.querySelector('.am .hdr');
    function onScroll() { if (hdr) hdr.classList.toggle('is-stuck', window.scrollY > 8); }
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

    var mnav = document.querySelector('.am .mnav');
    document.querySelectorAll('[data-nav-open]').forEach(function (b) { b.addEventListener('click', function () { if (mnav) { mnav.classList.add('open'); document.body.classList.add('am-nav-open'); } }); });
    document.querySelectorAll('[data-nav-close]').forEach(function (b) { b.addEventListener('click', function () { if (mnav) { mnav.classList.remove('open'); document.body.classList.remove('am-nav-open'); } }); });

    var inEditor = !!window.Shopify && !!window.Shopify.designMode;
    if (!inEditor && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
      document.querySelectorAll('.am .rv:not(.in)').forEach(function (el) { io.observe(el); });
    } else { document.querySelectorAll('.am .rv').forEach(function (el) { el.classList.add('in'); }); }

    document.querySelectorAll('.am .marquee .track:not([data-dup])').forEach(function (t) { t.setAttribute('data-dup', '1'); t.innerHTML += t.innerHTML; });

    document.querySelectorAll('[data-am-product]:not([data-ready])').forEach(function (pdp) {
      pdp.setAttribute('data-ready', '1');
      var variants = {};
      try { variants = JSON.parse(pdp.getAttribute('data-variants') || '{}'); } catch (e) { variants = {}; }
      var main = pdp.querySelector('[data-main]');
      var thumbs = pdp.querySelectorAll('.thumbs button');
      var swatches = pdp.querySelectorAll('.swatch');
      var lbl = pdp.querySelector('[data-color-name]');
      var idInputs = document.querySelectorAll('input.product-variant-id');
      var atcButtons = document.querySelectorAll('[data-atc-label]');
      function showImg(src, cut) {
        if (!main) return;
        main.src = src; main.removeAttribute('srcset'); main.className = cut ? 'cut' : '';
        thumbs.forEach(function (t) { if (t.getAttribute('data-src') === src) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { showImg(t.getAttribute('data-src'), t.hasAttribute('data-cut')); }); });
      function selectVariant(id, userAction) {
        var v = variants[id]; if (!v) return;
        swatches.forEach(function (s) { s.setAttribute('aria-checked', s.getAttribute('data-id') === String(id) ? 'true' : 'false'); });
        if (lbl) lbl.textContent = v.title;
        idInputs.forEach(function (i) { i.value = id; i.disabled = !v.available; });
        atcButtons.forEach(function (b) { b.disabled = !v.available; var s = b.querySelector('span'); if (s) s.textContent = v.available ? b.getAttribute('data-atc-label') : b.getAttribute('data-soldout-label'); });
        if (v.img) {
          if (thumbs[0] && thumbs[0].hasAttribute('data-variant-thumb')) { thumbs[0].setAttribute('data-src', v.img); var ti = thumbs[0].querySelector('img'); if (ti) { ti.src = v.img; ti.removeAttribute('srcset'); } }
          if (userAction) showImg(v.img, true);
        }
        if (userAction) { try { var u = new URL(location.href); u.searchParams.set('variant', id); history.replaceState(null, '', u.toString()); } catch (e) {} }
      }
      swatches.forEach(function (s) { s.addEventListener('click', function () { selectVariant(s.getAttribute('data-id'), true); }); });
      var initial = pdp.getAttribute('data-selected'); if (initial && variants[initial]) selectVariant(initial, false);

      var sticky = document.querySelector('.am .sticky-atc'); var cta = pdp.querySelector('.cta');
      if (sticky && cta && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { es.forEach(function (e) { sticky.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0); }); }, { threshold: 0 }).observe(cta);
        var sb = sticky.querySelector('[data-sticky-submit]'); var form = pdp.querySelector('form[data-type="add-to-cart-form"]');
        if (sb && form) sb.addEventListener('click', function () { var b = form.querySelector('button[type="submit"]'); if (b) b.click(); });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
